import { MessageCircle } from "lucide-react";
import { usePublicLang } from "@/contexts/PublicLangContext";
import { PUBLIC_BOOKING } from "@/constants/testIds";

/** Boton flotante de WhatsApp en la pagina publica de reservas. Solo se
 * renderiza si la clinica lo activo desde Ajustes y tiene un numero configurado. */
export default function PublicWhatsAppButton({ clinic }) {
  const { t } = usePublicLang();
  if (!clinic.public_whatsapp_help_enabled || !clinic.public_whatsapp_help_number) return null;

  const digits = clinic.public_whatsapp_help_number.replace(/[^\d]/g, "");
  const message = encodeURIComponent(clinic.public_whatsapp_help_message || "Hola, tengo una consulta sobre...");
  const href = `https://wa.me/${digits}?text=${message}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-5 right-5 z-50 flex items-center gap-2 bg-[#25D366] text-white pl-3 pr-4 py-3 rounded-full shadow-lg hover:scale-105 active:scale-95 transition-transform"
      data-testid={PUBLIC_BOOKING.whatsappHelpButton}
    >
      <MessageCircle className="w-5 h-5" />
      <span className="text-sm font-medium hidden sm:inline">{t("common.whatsappHelp")}</span>
    </a>
  );
}
